// Unified hover/focus behavior for ._region and ._map-key
(function () {
  // Resolve the "region id" from whatever we hovered/focused
  function getRegionIdFromTarget(target) {
    if (!(target instanceof Element)) return null;

    // Case 1: hovered a region
    const region = target.closest('._region');
    if (region && region.id) return region.id;

    // Case 2: hovered a map key -> read its <p id="...-text">
    const key = target.closest('._map-key');
    if (key) {
      const p = key.querySelector('p[id]');
      if (p && p.id) return p.id.replace(/-text$/, '');
    }
    return null;
  }

  // Toggle active on BOTH the region and its text partner, if present
  function setActiveForRegion(regionId, on) {
    const regionEl = document.getElementById(regionId);
    const textEl = document.getElementById(`${regionId}-text`);
    if (regionEl) regionEl.classList.toggle('active', on);
    if (textEl) textEl.classList.toggle('active', on);
  }

  // Don’t fire when moving between descendants of the same item
  function isInternalMove(container, related) {
    return related instanceof Node && container instanceof Element && container.contains(related);
  }

  // Pointer (hover): use bubbling pair + guard
  document.addEventListener('pointerover', (e) => {
    const container = (e.target instanceof Element) ? e.target.closest('._region, ._map-key') : null;
    if (!container || isInternalMove(container, e.relatedTarget)) return;

    const regionId = getRegionIdFromTarget(container);
    if (regionId) setActiveForRegion(regionId, true);
  });

  document.addEventListener('pointerout', (e) => {
    const container = (e.target instanceof Element) ? e.target.closest('._region, ._map-key') : null;
    if (!container || isInternalMove(container, e.relatedTarget)) return;

    const regionId = getRegionIdFromTarget(container);
    if (regionId) setActiveForRegion(regionId, false);
  });

  // Keyboard parity (accessibility): focus in/out
  document.addEventListener('focusin', (e) => {
    const regionId = getRegionIdFromTarget(e.target);
    if (regionId) setActiveForRegion(regionId, true);
  });

  document.addEventListener('focusout', (e) => {
    const regionId = getRegionIdFromTarget(e.target);
    if (regionId) setActiveForRegion(regionId, false);
  });
})();